import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import AsyncDashboard2 from '../../pages/AsyncDashboard2/AsyncDashboard2';
import LandingPage from '../../pages/Landing/LandingPage';

/** Logged-out `/` is the public site. Logged-in `/` stays the chat. */
const HomeRoute = (): JSX.Element => {
  const { authenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Loading</div>;
  }

  if (authenticated) {
    return <AsyncDashboard2 />;
  }

  return <LandingPage />;
};

export default HomeRoute;
